import { Divider, Typography } from 'antd'
import React from 'react'
import EOLGetBin from '../../../components/EOL/ViewBin/EOLGetBin'

const EOLViewBinPage = ({userData}) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography.Title
          level={5}
          style={{
            margin: 0,
          }}
        >
          View Bin
        </Typography.Title>
      </div>
      <Divider style={{ marginTop: 8 }} />
      <EOLGetBin userData={userData}/>

    </>
  )
}

export default EOLViewBinPage